import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters';
import app from './modules/app';
import settings from './modules/settings';
import user from './modules/user';
import decoration from './modules/decoration';
import secSend from './modules/sec-send';

import hotWords from './modules/hot-words';

Vue.use(Vuex);

const store = new Vuex.Store({
  strict: false,
  modules: {
    app,
    settings,
    decoration,
    user,
    hotWords,
    secSend,
  },
  getters,
});

export default store;
